import { ActionTypes as CardProjectActionTypes } from '../actions/projectActions';
import { ActionTypes as CardCustomizationActionTypes } from '../actions/cardCustomizationActions';

const initialState = {
  hasErrors: false,
  hasRecipientAddressing: false,
  errorsByElementUUID: []
};

const cardCustomizationBar = (state = initialState, action) => {
  switch (action.type) {
    case CardProjectActionTypes.TOGGLE_RECIPIENT_ADDRESSING_OPTION: {
      return { ...state, hasRecipientAddressing: action.payload };
    }
    case CardCustomizationActionTypes.CUSTOMIZATION_CLEANUP: {
      return {
        ...state,
        hasErrors: false,
        hasRecipientAddressing: false,
        errorsByElementUUID: []
      };
    }
    case CardCustomizationActionTypes.SET_CUSTOMIZATION_ERROR_LIST: {
      return {
        ...state,
        errorsByElementUUID: action.payload
      };
    }
    case CardCustomizationActionTypes.CLEAR_CUSTOMIZATION_ERROR_LIST: {
      return {
        ...state,
        errorsByElementUUID: []
      };
    }
    default:
      return state;
  }
};

export default cardCustomizationBar;



// WEBPACK FOOTER //
// ./src/cards/reducers/cardCustomizationBar.js